<template>
    <div>
        <NavbarOne />
        <MainBanner />
        <GetIntroduced />
        <Counter class="two-counter-area" />
        <WeHaveOffer />
        <CeoSection />
        <Services />
        
        <WebPack 
            :subTitle="$t('homepage.webpack.subTitle')" 
            :heading="$t('homepage.webpack.heading')" 
        />

        <MaintenancePlan />
        <ContactStrip /> 
        
        <GetAddress />
        <OurTeam class="two-team-area" />
        <FunFact />
        <CoustomerFeedbacks />
        <FrequentlyQuestion />
        <Faq />
        <ContactWithUs />
        <Blog class="two-blog-area" />
        <Subscribe />
        
        <AmongThem 
            :subTitle="$t('homepage.app.subTitle')" 
            :heading="$t('homepage.app.heading')" 
        />

        <Footer />
    </div>
</template>

<script>
import NavbarOne from '../Layouts/NavbarOne'
import MainBanner from '../HomeCreativa360/MainBanner'
import ContactStrip from '../HomeCreativa360/ContactStrip.vue';
import CeoSection from '../HomeCreativa360/CeoSection.vue'
import GetIntroduced from '../HomeCreativa360/GetIntroduced'
import Counter from '../Common/Counter'
import WeHaveOffer from '../HomeCreativa360/WeHaveOffer'
import MaintenancePlan from '../HomeCreativa360/MaintenancePlan'
import Services from '../HomeCreativa360/Services'
import WebPack from '../Common/WebPacks'
import GetAddress from '../HomeCreativa360/GetAddress'
import OurTeam from '../Common/OurTeam'
import FunFact from '../HomeCreativa360/FunFact'
import CoustomerFeedbacks from '../HomeCreativa360/CoustomerFeedbacks'
import FrequentlyQuestion from '../HomeCreativa360/FrequentlyQuestion'
import Faq from '../HomeCreativa360/Faq'
import ContactWithUs from '../HomeCreativa360/ContactWithUs'
import Blog from '../Common/Blog'
import Subscribe from '../HomeCreativa360/Subscribe'
import AmongThem from '../Common/AmongThem'
import Footer from '../Layouts/Footer'

export default {
    name: 'HomePageCreativa360',
    components: {
        NavbarOne,
        MainBanner,
        Counter, 
        WeHaveOffer,
        CeoSection,
        MaintenancePlan,
        ContactStrip,
        WebPack,
        Services,
        Footer, 
    }
}
</script>